// Until closedBy and commandFor are widely supported
const supportsClosedBy = 'closedBy' in HTMLDialogElement.prototype;
const supportsCommand = 'commandFor' in HTMLButtonElement.prototype;

if (!supportsClosedBy) {
  document.addEventListener('click', (e) => {
    const dialog = e.target instanceof HTMLDialogElement ? e.target : null;
    if (!dialog || !dialog.open) return;
    if (e.target === dialog) dialog.close();
  });
}

if (!supportsCommand) {
  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[commandfor][command="show-modal"]');
    if (!trigger) return;

    const id = trigger.getAttribute('commandfor');
    if (!id) return;

    const dialog = document.getElementById(id);
    if (!(dialog instanceof HTMLDialogElement)) return;

    dialog.showModal();
  });
}

window.showBundleProtectedDialog = function showBundleProtectedDialog() {
  const dialog = document.getElementById('bundle-protected-dialog');
  if (!(dialog instanceof HTMLDialogElement) || dialog.open) return;

  const cartDrawer = document.getElementById('cart-drawer');
  const home = dialog.parentElement;

  // An open modal dialog makes the rest of the document inert, so a sibling
  // <dialog> cannot be shown. Move this one inside the cart drawer first.
  if (cartDrawer instanceof HTMLDialogElement && cartDrawer.open) {
    cartDrawer.appendChild(dialog);
    dialog.addEventListener(
      'close',
      () => {
        if (home?.isConnected && dialog.parentElement !== home) {
          home.appendChild(dialog);
        }
      },
      { once: true }
    );
  }

  try {
    dialog.showModal();
  } catch {
    dialog.show();
  }
};

// Prevent auto :focus-visible for Safari
const prototype = HTMLDialogElement.prototype;
const nativeShowModal = prototype.showModal;
prototype.showModal = function (...args) {
  nativeShowModal.apply(this, args);
  this.focus({ preventScroll: true });
};


let dialog;

function getDialog() {
  if (dialog) return dialog;

  dialog = document.createElement('dialog');
  dialog.id = 'img-zoom';
  dialog.setAttribute('closedby', 'any');

  dialog.innerHTML = `
    <form method="dialog">
      <button type="submit" aria-label="Close">
        <svg viewBox="0 0 24 24" width="1.5rem" height="1.5rem">
          <line x1="2" y1="2" x2="22" y2="22" stroke="currentColor" stroke-width="3"></line>
          <line x1="22" y1="2" x2="2" y2="22" stroke="currentColor" stroke-width="3"></line>
        </svg>
      </button>
    </form>
    <div class="img-zoom-content"></div>
  `;

  document.body.appendChild(dialog);
  return dialog;
}

document.addEventListener('click', (e) => {
  if (matchMedia('(pointer: coarse)').matches) return;

  const img = e.target.closest('[zoomable]');
  if (!img) return;

  const d = getDialog();
  const content = d.querySelector('.img-zoom-content');
  content.replaceChildren();

  const carousel = img.closest('.carousel-media, .image-carousel');
  if (carousel) {
    openZoomCarousel(d, content, carousel, img);
    return;
  }

  const clone = img.cloneNode(true);
  clone.removeAttribute('zoomable');

  const open = () => {
    content.replaceChildren(clone);
    d.showModal();
  };

  if (clone.complete && clone.naturalWidth > 0) {
    open();
  } else {
    clone.addEventListener('load', open, { once: true });
  }
});

function openZoomCarousel(d, content, carousel, clickedImg) {
  const images = [...carousel.querySelectorAll('img[zoomable]')];
  const startIndex = images.indexOf(clickedImg);

  if (startIndex === -1) return;

  const viewport = document.createElement('div');
  viewport.className = 'zoom-gallery';

  const prev = document.createElement('button');
prev.type = 'button';
prev.className = 'zoom-gallery-prev';
prev.setAttribute('aria-label', 'Previous image');
prev.innerHTML = `
  <svg viewBox="0 0 24 24" width="1em" height="1em">
    <line x1="2" y1="12" x2="22" y2="12" fill="none" stroke="currentColor" stroke-width="2" />
    <polyline points="12,20 2,12 12,4" fill="none" stroke="currentColor" stroke-width="2" />
  </svg>
`;

const next = document.createElement('button');
next.type = 'button';
next.className = 'zoom-gallery-next';
next.setAttribute('aria-label', 'Next image');
next.innerHTML = `
  <svg viewBox="0 0 24 24" width="1em" height="1em">
    <line x1="1" y1="12" x2="21" y2="12" fill="none" stroke="currentColor" stroke-width="2" />
    <polyline points="12,20 22,12 12,4" fill="none" stroke="currentColor" stroke-width="2" />
  </svg>
`;

  const track = document.createElement('div');
  track.className = 'zoom-gallery-track';

  const slides = images.map((source) => {
    const slide = document.createElement('div');
    slide.className = 'zoom-gallery-slide';

    const clone = source.cloneNode(true);
    clone.removeAttribute('zoomable');
    clone.removeAttribute('loading');
    clone.removeAttribute('fetchpriority');

    slide.appendChild(clone);
    track.appendChild(slide);
    return slide;
  });

  let index = startIndex;

  const render = () => {
    slides.forEach((slide, i) => {
      slide.hidden = i !== index;
    });
  };

  const goTo = (nextIndex) => {
    index = (nextIndex + slides.length) % slides.length;
    render();
  };

  prev.addEventListener('click', () => goTo(index - 1));
  next.addEventListener('click', () => goTo(index + 1));

  const onKeydown = (e) => {
    if (!d.open) return;
    if (e.key === 'ArrowLeft') goTo(index - 1);
    if (e.key === 'ArrowRight') goTo(index + 1);
  };

  document.addEventListener('keydown', onKeydown);

  d.addEventListener(
    'close',
    () => {
      document.removeEventListener('keydown', onKeydown);
    },
    { once: true }
  );

  viewport.append(prev, track, next);
  content.replaceChildren(viewport);
  render();
  d.showModal();
}

document.addEventListener('click', (event) => {
  const btn = event.target.closest('.vertical-tablist button');
  if (!btn) return;

  const id = btn.getAttribute('aria-controls');
  if (!id) return;

  const panel = document.getElementById(id);
  if (!panel) return;

  let anchor = panel;
  while (anchor && getComputedStyle(anchor).position === 'absolute') {
    anchor = anchor.parentElement;
  }
  if (!anchor) return;

  requestAnimationFrame(() => {
    const wrapper = anchor.closest('[tabpanels]');

    const doScroll = () => {
      if (!needsScroll(anchor)) return;

      const prev = document.documentElement.style.overflowAnchor;
      document.documentElement.style.overflowAnchor = 'none';

      const scroller = document.scrollingElement || document.documentElement;

      const rem = parseFloat(getComputedStyle(document.documentElement).fontSize);
      const offset = 4 * rem;

      const y = anchor.getBoundingClientRect().top + scroller.scrollTop - offset;
      scroller.scrollTop = y;

      requestAnimationFrame(() => {
        document.documentElement.style.overflowAnchor = prev;
      });
    };

    if (!wrapper) {
      doScroll();
      return;
    }

    let done = false;
    const onEnd = (e) => {
      if (e.target !== wrapper || e.propertyName !== 'height') return;
      if (done) return;
      done = true;
      wrapper.removeEventListener('transitionend', onEnd);
      doScroll();
    };

    wrapper.addEventListener('transitionend', onEnd);

    requestAnimationFrame(() => {
      if (done) return;
      done = true;
      wrapper.removeEventListener('transitionend', onEnd);
      doScroll();
    });
  });
});

function needsScroll(anchor) {
  const rect = anchor.getBoundingClientRect();

  const rem = parseFloat(getComputedStyle(document.documentElement).fontSize);
  const offset = 4 * rem;

  return rect.top < offset || rect.top > window.innerHeight;
}

document.querySelectorAll('a[href="#live-chat"]').forEach((a) => {
  a.href = 'javascript:GorgiasChat.open();';
});

function setWrapperHeight(panel) {
  const wrapper = panel.closest('[tabpanels]');
  if (!wrapper) return;

  const styles = getComputedStyle(wrapper);
  const padding = parseFloat(styles.paddingTop) + parseFloat(styles.paddingBottom);

  wrapper.style.height = panel.offsetHeight + padding + 'px';
}

document.addEventListener('click', (event) => {
  const tab = event.target.closest('[role="tab"]');
  if (!tab) return;

  const tablist = tab.closest('[role="tablist"]');
  if (!tablist) return;

  if (tab.getAttribute('aria-selected') === 'true') return;

  const targetPanel = document.getElementById(tab.getAttribute('aria-controls'));
  if (!targetPanel) return;

  const currentTab = tablist.querySelector('[role="tab"][aria-selected="true"]');
  const currentPanel = currentTab ? document.getElementById(currentTab.getAttribute('aria-controls')) : null;

  if (currentTab) currentTab.setAttribute('aria-selected', 'false');
  tab.setAttribute('aria-selected', 'true');

  targetPanel.removeAttribute('inert');

  setWrapperHeight(targetPanel);

  if (currentPanel && currentPanel !== targetPanel) {
    currentPanel.setAttribute('inert', '');
  }

  document.querySelectorAll('[static]').forEach((p) => {
    p.removeAttribute('static');
  });
});

requestAnimationFrame(() => {
  document.querySelectorAll('[tabpanels]').forEach((wrapper) => {
    const active = wrapper.querySelector('[role="tabpanel"]:not([inert])');
    if (!active) return;

    setWrapperHeight(active);

  });
});

const resizeObserver = new ResizeObserver((entries) => {
  for (const entry of entries) {
    const panel = entry.target;

    if (panel.hasAttribute('inert')) continue;

    setWrapperHeight(panel);
  }
});

document.querySelectorAll('[role="tabpanel"]').forEach((panel) => resizeObserver.observe(panel));

window.addEventListener('resize', () => {
  requestAnimationFrame(() => {
    document.querySelectorAll('[tabpanels]').forEach((wrapper) => {
      const active = wrapper.querySelector('[role="tabpanel"]:not([inert])');
      if (active) setWrapperHeight(active);
    });
  });
});

function wrapMobileOverflowTables() {
  document.querySelectorAll('[data-mobile-table-overflow] table').forEach((table) => {
    if (table.closest('.injected-table-wrapper, .mobile-overscroll-wrapper')) return;

    const wrapper = document.createElement('div');
    wrapper.className = 'injected-table-wrapper';
    table.parentNode.insertBefore(wrapper, table);
    wrapper.appendChild(table);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', wrapMobileOverflowTables);
} else {
  wrapMobileOverflowTables();
}

document.addEventListener('click', (e) => {
    const asideLink = e.target.closest('.aside-nav a');

    if (asideLink) {
      document.querySelectorAll('.aside-nav a[aria-current="location"]').forEach((a) => {
        a.removeAttribute('aria-current');
      });

      asideLink.setAttribute('aria-current', 'location');
    }

    const mobileLink = e.target.closest('.mobile-aside a');

    if (mobileLink) {
      document.querySelectorAll('.mobile-aside .accordion-button[aria-expanded="true"]').forEach((button) => {
        button.setAttribute('aria-expanded', 'false');

        const panelId = button.getAttribute('aria-controls');
        const panel = panelId ? document.getElementById(panelId) : null;

        if (panel) {
          panel.inert = true;
        }
      });
    }
  });

  document.addEventListener('DOMContentLoaded', () => {
    const asideNav = document.querySelector('.aside-nav');
    const asideLinks = [...document.querySelectorAll('.aside-nav a[href^="#"]')];
    if (!asideNav || !asideLinks.length) return;

    const headings = asideLinks
      .map((link) => {
        const id = decodeURIComponent(link.getAttribute('href').slice(1));
        return document.getElementById(id);
      })
      .filter(Boolean);

    if (!headings.length) return;

    const updateMobileAsideLabel = (id) => {
      const activeLink = document.querySelector(`.aside-nav a[href="#${CSS.escape(id)}"]`);
      const mobileAsideSpan = document.querySelector('[aria-controls="panel-mobile-aside"] > span');

      if (activeLink && mobileAsideSpan) {
        mobileAsideSpan.textContent = activeLink.textContent.trim();
      }
    };

    const setCurrentLink = (id) => {
      document.querySelectorAll('.aside-nav a[aria-current="location"]').forEach((a) => {
        a.removeAttribute('aria-current');
      });

      const next = document.querySelector(`.aside-nav a[href="#${CSS.escape(id)}"]`);
      if (!next) return;

      next.setAttribute('aria-current', 'location');
      updateMobileAsideLabel(id);

      const firstLink = asideNav.querySelector('a[href^="#"]');
      const lastLink = asideLinks[asideLinks.length - 1];

      const navRect = asideNav.getBoundingClientRect();
      const linkRect = next.getBoundingClientRect();

      const isAbove = linkRect.top < navRect.top;
      const isBelow = linkRect.bottom > navRect.bottom;

      if (!isAbove && !isBelow) return;

      if (next === firstLink && isAbove) {
        asideNav.scrollTo({
          top: 0,
          behavior: 'smooth',
        });
        return;
      }

      if (next === lastLink && isBelow) {
        asideNav.scrollTo({
          top: asideNav.scrollHeight,
          behavior: 'smooth',
        });
        return;
      }

      const delta = isAbove ? linkRect.top - navRect.top : linkRect.bottom - navRect.bottom;

      asideNav.scrollBy({
        top: delta,
        behavior: 'smooth',
      });
    };

    const updateScrollSpy = () => {
      const triggerLine = Math.max(64, window.innerHeight * 0.3);
      let activeHeading = headings[0];

      for (const heading of headings) {
        if (heading.getBoundingClientRect().top <= triggerLine) {
          activeHeading = heading;
        } else {
          break;
        }
      }

      if (activeHeading) {
        setCurrentLink(activeHeading.id);
      }
    };

    updateScrollSpy();
    window.addEventListener('scroll', updateScrollSpy, { passive: true });
    window.addEventListener('resize', updateScrollSpy);
  });